// libs/core/auth/src/lib/tenant/tenant-auth.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthSession } from '../models/auth.types';
import { LoginPayload } from '../models/auth.interface';
import { AuthService } from '../data-access/auth.service';

@Injectable({ providedIn: 'root' })
export class TenantAuthService {
  constructor(private readonly auth: AuthService) {}

  login(payload: LoginPayload): Observable<AuthSession> {
    return this.auth.login(payload);
  }

  logout(): void {
    this.auth.logout();
  }

  isAuthenticated(): boolean {
    return this.auth.isAuthenticated();
  }

  getToken(): string | null {
    return this.auth.getToken();
  }

  getSnapshot() {
    return this.auth.getSnapshot();
  }
}